import React from "react";
import { IButton } from "../../hooks/types";

const Button: React.FC<IButton> = ({
  className,
  children,
  action,
  disabled,
}): React.JSX.Element => {
  // Render
  return (
    <button
      disabled={disabled}
      className={`${className} ${disabled && "bg-gray-500"}`}
      onClick={action}
    >
      {children}
    </button>
  );
};

export default Button;
